import mutations from './apmCommonState.mutations';
import actions from './apmCommonState.actions';
import getters from './apmCommonState.getters';
import { CAPABILITY_APM } from '@/utils/constants';

export interface State {
  capability: string;
  subtype: string;
  services: any[];
  instances: any[];
  endpoints: any[];
  databaseServices: any[];
  currentService: any;
  currentEndpoint: any;
  currentInstance: any;
  currentDatabaseService: any;
  updateDashboard: {};
  currentServiceApdex: Number;
  currentServiceLanguage: string;
  saveAllErrorTraces: boolean;
  minTraceLatency: Number;
  maxSpansPerTraces: Number;
  minDbQueryLatency: Number;
}

const initialState: State = {
  capability: CAPABILITY_APM,
  subtype : '',
  services: [],
  instances: [],
  endpoints: [],
  databaseServices: [],
  currentService: {},
  currentEndpoint: {},
  currentInstance: {},
  currentDatabaseService: {},
  updateDashboard: {},
  currentServiceApdex: 0,
  currentServiceLanguage: '',
  saveAllErrorTraces: true,
  minTraceLatency: 0,
  maxSpansPerTraces: 0,
  minDbQueryLatency: 0
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
